// extracted by mini-css-extract-plugin
export default {"videoPlayer":"VideoApp_videoPlayer__TW8H4"};